import React from "react";
import { SvgIcon } from "@material-ui/core";

/**
 * Ícono message-square (Figma barra-de-contacto · Afiliaciones).
 * Stroke 2, viewBox 32×32.
 */
const IconAfiliaciones = props => (
  <SvgIcon viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M28.5537 24.5524C29.0538 24.0523 29.3348 23.374 29.3348 22.6668V6.66668C29.3348 5.95943 29.0538 5.28115 28.5537 4.78105C28.0536 4.28095 27.3752 4 26.6679 4H5.3329C4.6256 4 3.94726 4.28095 3.44713 4.78105C2.94699 5.28115 2.66602 5.95943 2.66602 6.66668V28.3815C2.66604 28.5687 2.72158 28.7517 2.82561 28.9073C2.92964 29.063 3.07749 29.1843 3.25047 29.2559C3.42345 29.3276 3.61379 29.3463 3.79742 29.3098C3.98106 29.2733 4.14974 29.1832 4.28214 29.0508L7.21838 26.1148C7.7184 25.6146 8.39662 25.3336 9.10386 25.3334H26.6679C27.3752 25.3334 28.0536 25.0525 28.5537 24.5524Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </SvgIcon>
);

export default IconAfiliaciones;
